import checkout from "./formNull";

const {
  formFieldNull: {
  },
} = checkout;

const initialValuesNull = {
};

export default initialValuesNull;
